import { Text } from '@doist/marketist';
import cn from 'clsx';
import css from './product-ui-segmented-control.module.css';
export type ProductUISegmentedControlProps = {
  children?: React.ReactNode;
};
export function ProductUISegmentedControl({
  children
}: ProductUISegmentedControlProps) {
  return <div className={css.productUISegmentedControl} data-sentry-component="ProductUISegmentedControl" data-sentry-source-file="product-ui-segmented-control.tsx">{children}</div>;
}
ProductUISegmentedControl.Item = function ProductUISegmentedControlItem({
  children,
  selected
}: {
  children: React.ReactNode;
  selected?: boolean;
}) {
  return <Text size="body-xs" className={cn(css.productUISegmentedControlItem, {
    [css.selected]: selected
  })}>
            {children}
        </Text>;
};